import React, { useContext, useEffect, useMemo, useState } from "react";
import { Card, Col, Form } from "react-bootstrap";
// import UploadFile from "../../../kits/UploadFile/index.tsx";
import UploadFile from "assets/kits/UploadFile/index.tsx";
import Swal from "sweetalert2";
import { FaTrash } from "react-icons/fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import { onlyNumber } from "../../../../utils/Tools";
import { addCommas } from "@persian-tools/persian-tools";

const InventoryItemProduct = ({
  isOptions = false,
  details,
  setInventorys,
}) => {
  const handelChange = (key, value) => {
    setInventorys((prev) => [
      ...prev.map((it) => {
        if (it.index != details.index) return it;
        return {
          ...it,
          [key]: value,
        };
      }),
    ]);
  };

  const [file, setFile] = useState({ file: {} });

  const setfilesMemo = useMemo(() => {
    setFile({ file: details.file });
  }, [details.file]);

  useEffect(() => {
    handelChange("file", file.file);
  }, [file]);

  useEffect(() => {}, [details]);
  console.log('submit',details);
  return (
    <Card className="shadow-sm mr-t-12">
      <Card.Body className="d-flex flex-column flex-lg-row justify-content-center font-14-500 align-items-center pd-12">
        {isOptions && (
          <Col xs={"auto"} className="pd-x-6">
            <UploadFile
              name="file"
              file={file}
              setFile={setFile}
              typeFile="image"
            />
          </Col>
        )}

        <div className="d-flex flex-wrap w-100">
          <Col
            xs={12}
            md
            className="d-flex flex-row flex-lg-column align-items-center mr-t-16 pd-x-6"
          >
            <span className="col-3 col-lg-12 mr-b-8 text-nowrap text-center text-lg-start">
              قیمت<span className="font-12-500"> (تومان) </span>:
            </span>
            <Form.Control
              className="shadow-none he-40 rd-8 pd-x-12 font-14-500"
              placeholder="قیمت را وارد نمایید"
              value={addCommas(details?.price)}
              onChange={({ target }) => {
                if (target.value == details.price) return;
                handelChange("price", onlyNumber(target.value, true));
              }}
            />
          </Col>

          <Col
            xs={12}
            md
            className="d-flex flex-row flex-lg-column align-items-center mr-t-16 pd-x-6"
          >
            <span className="col-3 col-lg-12 mr-b-8 text-nowrap text-center text-lg-start">
              موجودی:
            </span>
            <Form.Control
              className="shadow-none he-40 rd-8 pd-x-12 font-14-500"
              placeholder="تعداد را وارد نمایید"
              value={addCommas(details?.inventory)}
              onChange={({ target }) => {
                if (target.value == details.inventory) return;
                handelChange("inventory", onlyNumber(target.value, true));
              }}
            />
          </Col>
        </div>

        <div className="d-flex flex-wrap w-100">
          <Col
            xs={12}
            md
            className="d-flex flex-row flex-lg-column align-items-center mr-t-16 pd-x-6"
          >
            <span className="col-3 col-lg-12 mr-b-8 text-nowrap text-center text-lg-start">
              تخفیف<span className="font-12-500">(%)</span>:
            </span>
            <Form.Control
              className="shadow-none he-40 rd-8 pd-x-12 font-14-500 "
              placeholder="تخفیف را وارد نمایید"
              value={details?.discount}
              onChange={({ target }) => {
                if (target.value > 100 || target.value == details.discount)
                  return;
                handelChange("discount", onlyNumber(target.value));
              }}
            />
          </Col>
          <Col
            xs={12}
            md
            className="d-flex flex-row flex-lg-column align-items-center mr-t-16 pd-x-6"
          >
            <span className="col-3 col-lg-12 mr-b-8 text-center text-lg-start">
              تاریخ تخفیف:
            </span>

            <DatePicker
              value={details.discountTime && details.discountTime * 1000}
              onChange={(value) => {
                handelChange("discountTime", value == null ? "" : value.unix);
              }}
              calendar={persian}
              locale={persian_fa}
              showOtherDays
              minDate={new DateObject({ calendar: persian })}
              placeholder="تاریخ تخفیف را وارد نمایید"
              // containerClassName="col-9 col-lg-12"
              inputClass="form-control shadow-none he-40 rd-8 pd-x-12 font-14-500 w-100"
            />
          </Col>
          {/* <Col
            xs={12}
            md
            className="d-flex flex-row flex-lg-column align-items-center mr-t-16 pd-x-6"
          >
            <span className="col-3 col-lg-12 mr-b-8 text-center text-lg-start">
              کد حسابداری:
            </span>
            <Form.Control
              className="shadow-none he-40 rd-8 pd-x-12 font-14-500 "
              placeholder="کدجسابداری را وارد نمایید"
              value={details?.accounting_code}
              disabled={true}
              onChange={({ target }) => {
              
                handelChange("accounting_code", onlyNumber(target.value));
              }}
            />
          </Col> */}
        </div>

        <div className="col-auto d-flex justify-content-center align-items-center mr-r-16 mr-t-16">
          {/*<GiSave*/}
          {/*  className="ms-1 list-item wh-30 pd-6 opacity-50 rd-4 color-white pointer bg-warning is-invalid"*/}
          {/*  data-tooltip-id="my-tooltip"*/}
          {/*  data-tooltip-content="ویرایش"*/}
          {/*/>*/}

          <FaTrash
            onClick={() => {
              Swal.fire({
                title: "آیا از حذف این موجودی مطمئن هستید؟",
                showDenyButton: true,
                confirmButtonColor: "rgb(25,135,84)",
                confirmButtonText: "بله",
                denyButtonText: `خیر`,
              }).then(({ isConfirmed }) => {
                if (isConfirmed)
                  setInventorys((prev) =>
                    prev.filter((it) => it.index != details.index)
                  );
              });
            }}
            className="ms-1 list-item wh-30 pd-6 rd-4 color-white pointer bg-danger"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="حذف"
          />
        </div>
      </Card.Body>

      {isOptions && (
        <Card.Footer className="d-flex flex-row justify-content-start">
          <Col xs className="d-flex pd-x-6 flex-wrap">
            {details?.optionValue.map((item) => (
              // <Col xs className="d-flex pd-x-6 flex-wrap">
              <OptionItemAndValue item={item} />
              // </Col>
            ))}
          </Col>
        </Card.Footer>
      )}
    </Card>
  );
};

const OptionItemAndValue = ({
  item,
  color = "white",
  bgColor = "rgb(13,110,253)",
}) => {
  return (
    <div
      style={{ backgroundColor: bgColor, color: color }}
      className={`d-flex bg-opacity-75  rd-4 font-10-400 pd-y-4 pd-x-8 w-auto mr-2`}
    >
      <span className="pd-l-6">{item.title}</span>
      <div className="border" />
      <span className="pd-r-6">{item.txt}</span>
    </div>
  );
};
export default InventoryItemProduct;

export { OptionItemAndValue };
